export default __webpack_public_path__ + "static/media/toy9.18d3f24a.jfif";